// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1R3SC","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__34Guk"};